import { FC } from 'react';
import {
  ACTIONS,
  FEATURE_TEAMS,
  LocationNode,
  LocationPicker as ExternalLocationPicker,
  LocationPickerProps as ExternalLocationPickerProps,
} from '@adsk/acc-locations-components';
import { RfiLocationId } from '../sdk/types';
import { translate } from '../helpers';
import { EMPTY_ARRAY } from '../constants';

export type LocationPickerProps = Omit<
  ExternalLocationPickerProps,
  'onNodeSelect' | 'featureTeam' | 'selectedNodesIds'
> & {
  onChangeLocationIds: (locationIds: RfiLocationId[]) => void;
  selectedLocationIds?: ExternalLocationPickerProps['selectedNodesIds'] | null;
  disabled?: boolean;
};

const PureLocationPicker: FC<LocationPickerProps> = ({
  onChangeLocationIds,
  selectedLocationIds,
  disabled = false,
  action = ACTIONS.ASSIGN,
  hideIncludeSubLocations = true,
  includeSubLocations = false,
  ...locationPickerProps
}) => {
  const onNodeSelect = (node: LocationNode | LocationNode[] | null) => {
    let selectedIds: RfiLocationId[] = [];

    if (node) {
      selectedIds = Array.isArray(node) ? (node as LocationNode[]).map(({ id }) => id) : [node.id];
    }

    onChangeLocationIds(selectedIds);
  };

  return (
    <ExternalLocationPicker
      disabled={disabled}
      clearable
      multiple
      hideIncludeSubLocations={hideIncludeSubLocations}
      selectedNodesIds={selectedLocationIds || EMPTY_ARRAY}
      includeSubLocations={includeSubLocations}
      featureTeam={FEATURE_TEAMS.RFIS}
      action={action}
      onNodeSelect={onNodeSelect}
      selectLocationPlaceHolder={translate('new.placeholder.location')}
      {...locationPickerProps}
    />
  );
};

export const LocationPicker = Object.assign(PureLocationPicker, {
  ACTIONS,
});
